import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from 'src/app/shared.module';
import { WidgetsComponentsModule } from 'src/app/components/kit/widgets/widgets-components.module';
import { FormsModule } from '@angular/forms';
import { LayoutModule } from '../cleanui/layout/layout.module';
import { FeatherModule } from 'angular-feather';
import { SplitbuttonComponent } from './splitbutton/splitbutton.component';
import { SelectExportsButtonComponent } from './exports/select-exports-button.component';
import { DatePickerComponent } from '@app/components/elements/date-picker/date-picker.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BadgeButtonComponent } from '@app/components/elements/badge-button/badge-button.component';
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { WfsStateLabelComponent } from 'src/app/components/elements/badge-icon/wfs-state-label.component';
import { TimelineModule } from '@app/components/elements/timeline/timeline.module';
import { SplitButtonElementsCollectorDirective } from '@app/directives/splitbutton-elements-collector/splitbutton-elements-collector.directive';
import { SplitButtonBulkProviderDirective } from '@app/directives/splitbutton-bulk-provider/splitbutton-bulk-provider.directive';
import { DatePickerValueAccessorDirective } from '@app/components/elements/date-picker/date-picker-value-accessor.directive';

const EXPORT_COMPONENTS = [
	BadgeButtonComponent,
	SplitbuttonComponent,
	SplitButtonBulkProviderDirective,
	SplitButtonElementsCollectorDirective,
	SelectExportsButtonComponent,
	DatePickerComponent,
	DatePickerValueAccessorDirective,
	WfsStateLabelComponent,
];

@NgModule({
	imports: [
		SharedModule,
		WidgetsComponentsModule,
		FormsModule,
		LayoutModule,
		FeatherModule,
		NzToolTipModule,
		TimelineModule
	],
	exports: [
		...EXPORT_COMPONENTS,
		TimelineModule
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA,
	],
	providers: [
		TranslatePipe,
	],
	declarations: [
		LoginDialogComponent,
		...EXPORT_COMPONENTS
	]
})
export class ElementsModule {}
